var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSadEmoji(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8364 24.8364 32 16 32C7.16444 32 0 24.8364 0 16C0 7.16444 7.16444 0 16 0C24.8364 0 32 7.16444 32 16Z",
    fill: "#FFCC4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2222 15.9996C11.4495 15.9996 12.4444 14.6067 12.4444 12.8885C12.4444 11.1702 11.4495 9.77734 10.2222 9.77734C8.99492 9.77734 8 11.1702 8 12.8885C8 14.6067 8.99492 15.9996 10.2222 15.9996Z",
    fill: "#664500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7769 15.9996C23.0042 15.9996 23.9991 14.6067 23.9991 12.8885C23.9991 11.1702 23.0042 9.77734 21.7769 9.77734C20.5496 9.77734 19.5547 11.1702 19.5547 12.8885C19.5547 14.6067 20.5496 15.9996 21.7769 15.9996Z",
    fill: "#664500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70167 24.7734C7.85989 24.9165 8.09634 24.9254 8.26611 24.7991C8.30078 24.7734 11.7523 22.2214 15.9994 22.2214C20.2359 22.2214 23.699 24.7734 23.7328 24.7991C23.9026 24.9254 24.139 24.9147 24.2972 24.7734C24.4546 24.6311 24.4901 24.3965 24.3808 24.2151C24.2661 24.0249 21.5212 19.5547 15.9994 19.5547C10.4777 19.5547 7.73189 24.024 7.61811 24.2151C7.50878 24.3974 7.54345 24.6311 7.70167 24.7734Z",
    fill: "#664500"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadEmoji);
export default __webpack_public_path__ + "static/media/sad_emoji.64015c17455e72db9a0535d87d4f2ff5.svg";
export { ForwardRef as ReactComponent };